// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../../assets/add.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FullSessionList{
    display: flex;
    flex-direction: column;
    gap: 12px;
    overflow-y: auto;
    height: 100%;
    background-color: #f9f9f6;
    width: 100%;
    --inner-padding: 15px;
    padding-top: calc(46px - var(--inner-padding));
    padding-left: calc(30px - var(--inner-padding));
    padding-right: calc(56px - var(--inner-padding));
    padding-bottom: calc(30px - var(--inner-padding));
}

.FullSessionList_group{
    display: flex;
    flex-direction: column;
    gap: 7px;
}

.FullSessionList_collapser{
    --shadowCompensation: 10px;
    margin: calc(0px - var(--shadowCompensation));
    min-height: var(--shadowCompensation);
}

.FullSessionList_collapserGroup{
    display: flex;
    flex-direction: column;
    gap: 7px;
    padding: var(--shadowCompensation);
}

.FullSessionList_groupLabel{
    --width: 140px;
    color: #B8BCCA;
    fill: #B8BCCA;
}

.FullSessionList_header{
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    display: none;
}

.FullSessionList_form{
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: 8px;
}

.FullSessionList_title{
    font-weight: 400;
    font-size: calc(14px * var(--fontScaler));
    line-height: 19px;

    color: #8E9ABB;
}

.FullSessionList_sessions{
    display: flex;
    flex-direction: column;
    gap: 7px;
    margin-bottom: 30px;
    padding: var(--inner-padding);
}

.FullSessionList_spinner {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    width: 100%;
}

.FullSessionList_noSessions {
    text-align: center;
    color: #8E9ABB;
    padding: 20px;
    font-size: calc(14px * var(--fontScaler));
}

.FullSessionList_noSessions{
    font-style: italic;
    font-weight: 400;
    font-size: calc(14px * var(--fontScaler));
    line-height: 24px;
    text-align: center;
    color: #979797;
}

.FullSessionList_sessions_scroll{
    overflow-y: hidden;
    height: 100%;
}

.FullSessionList_buttons{
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    gap: 26px;
    height: 5px;
    padding-right: 15px;
}

.FullSessionList_save{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 40px;
    gap: 10px;

    background: #FFA825;
    border-radius: 24px;
}

.FullSessionList_add{
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.1));
    background: #FFFFFF;
    border: 1px solid #FFA825;

    width: 49px;
    height: 49px;
    border-radius: 100%;
    flex-shrink: 0;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 18px;
    background-position: center;
    background-repeat: no-repeat;
    font-size: 0;
}

.FullSessionList_spinner {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    width: 100%;
}

.FullSessionList_loadMoreButton {
    background: #FFA825;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 20px;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.2s ease;
}

.FullSessionList_loadMoreButton:hover {
    background: #e89520;
}

.FullSessionList_loadMoreButton:disabled {
    background: #ccc;
    cursor: not-allowed;
}

.FullSessionList_empty {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    width: 100%;
    color: #777;
    font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/sessions/fullSessionList/FullSessionList.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,qBAAqB;IACrB,8CAA8C;IAC9C,+CAA+C;IAC/C,gDAAgD;IAChD,iDAAiD;AACrD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,0BAA0B;IAC1B,6CAA6C;IAC7C,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;;IAEjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,qBAAqB;IACrB,SAAS;IACT,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;;IAET,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mDAAmD;IACnD,mBAAmB;IACnB,yBAAyB;;IAEzB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;;IAEd,yDAAsD;IACtD,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,WAAW;IACX,kBAAkB;AACtB","sourcesContent":[".FullSessionList{\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    overflow-y: auto;\n    height: 100%;\n    background-color: #f9f9f6;\n    width: 100%;\n    --inner-padding: 15px;\n    padding-top: calc(46px - var(--inner-padding));\n    padding-left: calc(30px - var(--inner-padding));\n    padding-right: calc(56px - var(--inner-padding));\n    padding-bottom: calc(30px - var(--inner-padding));\n}\n\n.FullSessionList_group{\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n}\n\n.FullSessionList_collapser{\n    --shadowCompensation: 10px;\n    margin: calc(0px - var(--shadowCompensation));\n    min-height: var(--shadowCompensation);\n}\n\n.FullSessionList_collapserGroup{\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n    padding: var(--shadowCompensation);\n}\n\n.FullSessionList_groupLabel{\n    --width: 140px;\n    color: #B8BCCA;\n    fill: #B8BCCA;\n}\n\n.FullSessionList_header{\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 12px;\n    display: none;\n}\n\n.FullSessionList_form{\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    gap: 8px;\n}\n\n.FullSessionList_title{\n    font-weight: 400;\n    font-size: calc(14px * var(--fontScaler));\n    line-height: 19px;\n\n    color: #8E9ABB;\n}\n\n.FullSessionList_sessions{\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n    margin-bottom: 30px;\n    padding: var(--inner-padding);\n}\n\n.FullSessionList_spinner {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 20px;\n    width: 100%;\n}\n\n.FullSessionList_noSessions {\n    text-align: center;\n    color: #8E9ABB;\n    padding: 20px;\n    font-size: calc(14px * var(--fontScaler));\n}\n\n.FullSessionList_noSessions{\n    font-style: italic;\n    font-weight: 400;\n    font-size: calc(14px * var(--fontScaler));\n    line-height: 24px;\n    text-align: center;\n    color: #979797;\n}\n\n.FullSessionList_sessions_scroll{\n    overflow-y: hidden;\n    height: 100%;\n}\n\n.FullSessionList_buttons{\n    display: flex;\n    justify-content: flex-end;\n    align-items: flex-end;\n    gap: 26px;\n    height: 5px;\n    padding-right: 15px;\n}\n\n.FullSessionList_save{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 10px 40px;\n    gap: 10px;\n\n    background: #FFA825;\n    border-radius: 24px;\n}\n\n.FullSessionList_add{\n    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.1));\n    background: #FFFFFF;\n    border: 1px solid #FFA825;\n\n    width: 49px;\n    height: 49px;\n    border-radius: 100%;\n    flex-shrink: 0;\n\n    background-image: url('../../../../../assets/add.svg');\n    background-size: 18px;\n    background-position: center;\n    background-repeat: no-repeat;\n    font-size: 0;\n}\n\n.FullSessionList_spinner {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100px;\n    width: 100%;\n}\n\n.FullSessionList_loadMoreButton {\n    background: #FFA825;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 20px;\n    cursor: pointer;\n    font-size: 14px;\n    transition: background-color 0.2s ease;\n}\n\n.FullSessionList_loadMoreButton:hover {\n    background: #e89520;\n}\n\n.FullSessionList_loadMoreButton:disabled {\n    background: #ccc;\n    cursor: not-allowed;\n}\n\n.FullSessionList_empty {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100px;\n    width: 100%;\n    color: #777;\n    font-style: italic;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
